import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faStar } from "@fortawesome/free-solid-svg-icons";
import styled, { keyframes } from "styled-components";
import Product from "./Product";
import { useLocation } from "react-router-dom";
import { API_BASE_URL } from "../config";
import { useInvoiceContext } from "../context";

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  15% {
    transform: rotate(20deg);
  }
  30% {
    transform: rotate(0deg);
  }
  45% {
    transform: rotate(20deg);
  }
  60% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

const zoomIn = keyframes`
  from {
    transform: scale(0.5);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

const AnimatedIcon = styled(FontAwesomeIcon)`
  animation: ${rotate} 1.5s infinite;
`;

const AnimatedCard = styled(Card)`
  animation: ${zoomIn} 1s ease-in-out;
`;

const CardUpSell = (props) => {
  const location = useLocation();
  const queryString = new URLSearchParams(location.search);
  const cartquery = queryString.get("cart");

  const [show, setShow] = useState(false);
  const [products, setProducts] = useState([]);

  const { cart, addItemInCart } = useInvoiceContext();

  useEffect(() => {
    const fetchCart = async () => {
      const response = await fetch(`${API_BASE_URL}/getupsellcart/${cartquery}`);
      const jsonData = await response.json();

      const status = response.status;

      if (status === 200) {
        setProducts(jsonData.products);
      }
    };

    if (cartquery) {
      fetchCart();

      setTimeout(() => {
        console.log(products);
        if (products.length > 0) {
          setShow(true);
        }
      }, 2000); // Atraso de 2000ms
    }
  }, [cartquery, products.length]);

  const isInCart = (product) => {
    return cart.some(cartItem => cartItem.id === product.id);
  };

  const addItemToCart = (product) => {
    addItemInCart(product);
  }

  return (
    <AnimatedCard
      border="default"
      className="mb-3"
      bg="warning"
      style={{ display: show ? "flex" : "none" }}
    >
      <Card.Header
        style={{
          backgroundColor: "#f6d257f2",
          borderBottom: "1px solid #d6a304",
          borderTopLeftRadius: "0.3rem",
        }}
      >
        <AnimatedIcon
          icon={faStar}
          color="black"
        />
        <strong>{" "}Faça um upgrade!</strong>
      </Card.Header>
      <Card.Body
        style={{
          backgroundColor: "white",
          borderRadius: "0 0 0.3rem 0.3rem",
        }}
      >
        {
          products.filter(product => !isInCart(product)).map((product, index) => (
            <Product
              key={index}
              index={index}
              name={product.name}
              desc={product.desc}
              price={parseFloat(product.price)}
              fullPrice={parseFloat(product.full_price)}
              actionText={"Adicionar"}
              actionHoverColor="#69b190"
              actionIcon={faPlus}
              actionOnClick={() => addItemToCart(product)} // Passe o produto diretamente
              actionIconSize="30px"
              showEndLine={false}
              hasInfo={product.tem_info}
              info={product.info}
            />
          ))
        }
      </Card.Body>
    </AnimatedCard>
  );
}

export default CardUpSell;